import Vue from 'vue'
import Vuex from 'vuex'
import App from './modules/App';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuOpen: false,
    activeMenuFooter: false,
    activeFormFloating: false,
    isDesktop: null,
    activeBackdrop: false,
  },
  getters: {
    menuOpen(state) {
      return state.menuOpen;
    },
    activeMenuFooter(state) {
      return state.activeMenuFooter;
    },
    activeFormFloating(state) {
      return state.activeFormFloating;
    },
    isDesktop(state) {
      return state.isDesktop;
    },
    activeBackdrop(state) {
      return state.activeBackdrop;
    },
  },
  mutations: {
    setMenuOpen(state, value){
      state.menuOpen = value;
    },
    setActiveMenuFooter(state, value){
      state.activeMenuFooter = value;
    },
    setActiveFormFloating(state, value){
      state.activeFormFloating = value;
    },
    setIsDesktop(state, value){
      state.isDesktop = value;
    },
    setActiveBackdrop(state, value){
      state.activeBackdrop = value;
      if (value){
        document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
      } else {
        document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
      }
    },
  },
  actions: {
    toggleFormFixed(context){
      if (context.getters.isDesktop){
        context.commit('setActiveFormFloating', !context.getters.activeFormFloating);
        if (context.getters.activeFormFloating){
          document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
          document.getElementsByClassName('backdrop_bar')[0].classList.remove('d-none');
        } else {
          document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
          document.getElementsByClassName('backdrop_bar')[0].classList.add('d-none');
        }
      }else {
        if (context.getters.activeMenuFooter){
          context.commit('setActiveMenuFooter', false);
        }else {
          context.commit('setActiveMenuFooter', true);
        }
      }
    },
    setMenuOpen(context, value) {
      context.commit('setActiveBackdrop', value);
      context.commit('setMenuOpen', value);
    },
  },
  modules: {
    App,  
  },
})
